import * as Plyr from "plyr"
import "../scripts/page-transition"
import "../scripts/headerMobile"
import "../scripts/casesCarousel"
;(window as any).Plyr = (Plyr as any).default || Plyr
